import { Action, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "../../reducers";
import axiosApi from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import { getCompanyId, getOrganisationType } from "../../../Authentication/Auth";

export const ACTION_GET_ORGANISATION_NAME = "ACTION_GET_ORGANISATION_NAME";

export interface ActionGetOrganisationName {
  readonly type: typeof ACTION_GET_ORGANISATION_NAME;
  readonly payload: string;
}

export default (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async (dispatch) => {
  axiosApi
    .get<string>(`${BackendServices.USER_SERVICE.USER}/GetOrganisationName?id=${getCompanyId()}&Type=${getOrganisationType()}`)
    .then(({ data: payload }) => {
      const action: ActionGetOrganisationName = {
        type: ACTION_GET_ORGANISATION_NAME,
        payload,
      };

      // Store in session storage
      if(payload) {
        sessionStorage.setItem('OrganisationName', payload);
      }
      
      dispatch(action);
    })
    .catch(() => {
      dispatch({ type: ACTION_GET_ORGANISATION_NAME, payload: [] });
    });
};
